import { render } from "./CollaborationChecklist.vue.js?vue&type=template&id=80a0af92!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CollaborationChecklist.vue?vue&type=template&id=80a0af92"
import script from "./CollaborationChecklist.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CollaborationChecklist.vue?vue&type=script&lang=js"
export * from "./CollaborationChecklist.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CollaborationChecklist.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/components/onboarding/CollaborationChecklist.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "80a0af92"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('80a0af92', __exports__)) {
    api.reload('80a0af92', __exports__)
  }
  
  module.hot.accept("./CollaborationChecklist.vue.js?vue&type=template&id=80a0af92!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CollaborationChecklist.vue?vue&type=template&id=80a0af92", () => {
    api.rerender('80a0af92', render)
  })

}


export default __exports__